<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">
        {{ data?.heading | titlecase }}
      </span>
      <button
        mat-icon-button
        [mat-dialog-close]="false"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <p class="mt-0" fxLayout="row" fxLayoutAlign="start center">
      <span fxFlex>Courier: </span>
      <span fxFlex class="mx-12">{{
        data?.details?.price?.courierObj?.courier_service
      }}</span>
    </p>

    <ng-container
      *ngIf="
        data?.heading === 'charged weight details';
        else shippingChargeDetails
      "
    >
      <p>
        <span fxFlex>Actual Weight: </span
        ><span fxFlex
          >{{ price?.deadWeight | weightConversionTo: "kg" }} Kg
        </span>
      </p>

      <p>
        <span fxFlex>Volumetric Weight: </span
        ><span fxFlex
          >{{ price?.volWeight | weightConversionTo: "kg" }} Kg</span
        >
      </p>

      <p>*Higher of the two will be charged.</p>
    </ng-container>

    <ng-template #shippingChargeDetails>
      <p *ngIf="basePrice">
        <span fxFlex>Base Price: </span
        ><span fxFlex>{{ basePrice | currency: "INR" }} </span>
      </p>

      <p *ngIf="reverseBasePrice">
        <span fxFlex>Reverse Base Price: </span
        ><span fxFlex>{{ reverseBasePrice | currency: "INR" }} </span>
      </p>

      <p *ngIf="!reverseBasePrice">
        <span fxFlex>COD Service Cost: </span
        ><span fxFlex>{{ codServiceCost | currency: "INR" }} </span>
      </p>

      <p *ngIf="reverseGSTPrice">
        <span fxFlex>Reverse GST Price: </span
        ><span fxFlex>{{ reverseGSTPrice | currency: "INR" }} </span>
      </p>

      <p>
        <span fxFlex>Total Price: </span
        ><span fxFlex>{{ fullPrice | currency: "INR" }}</span>
      </p>
      <p>* Total Price inclusive of GST</p>
    </ng-template>
  </div>
</div>
